import React, { useState, useEffect } from 'react'
import Input from '../forms/input/Input'
import styles from './HomePage.module.scss'
import validationSchema from '../../utilities/validationschema'
import Button from '../forms/Button/Button'
import { useTranslation } from 'react-i18next'

const SingleButtonForm = ({ buttonText, onClick, value, placeholder, showPhoneInput, emailNotFoundMessage }) => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [emailError, setEmailError] = useState(null);
  const [phoneError, setPhoneError] = useState(null);

  const { t } = useTranslation()
  const schema = validationSchema(t)
  const phonePlaceholder = t('phonePlaceholder')

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    setEmail(inputValue);

    try {
      schema['email'].parse(inputValue);
      setEmailError(null);
    } catch (error) {
      setEmailError(error.errors[0]?.message);
    }
  };

  const handlePhoneChange = (e) => {
    const inputValue = e.target.value;
    setPhone(inputValue);

    try {
      schema['phone'].parse(inputValue);
      setPhoneError(null);
    } catch (error) {
      setPhoneError(error.errors[0]?.message);
    }
  };

  const getEmailFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('email') || '';
  };

  useEffect(() => {
    const emailFromUrl = getEmailFromUrl();
    setEmail(decodeURIComponent(emailFromUrl));
  }, []);

  const isEmailInvalid = email.trim() === '' || !!emailError;
  const isPhoneInvalid = phone.trim() === '' || !!phoneError;
  const isSubmitDisabled = showPhoneInput ? isPhoneInvalid : isEmailInvalid;

  return (
    <>
      <div className={styles.threeSection}>
        <Input
          autofocus={!showPhoneInput}
          name="email"
          type="text"
          placeholder={placeholder}
          schema={schema['email']}
          onChange={handleEmailChange}
          value={email}
          disabled={showPhoneInput}
        />
        {showPhoneInput && (
          <>
            {emailNotFoundMessage && (
              <p className={styles.notFoundMessage}>{emailNotFoundMessage}</p>
            )}
            <Input
              autofocus
              name="phone"
              type="tel"
              placeholder={phonePlaceholder}
              schema={schema['phone']}
              onChange={handlePhoneChange}
              value={phone}
            />
          </>
        )}
        <div className={`${styles.buttonContainer} ${isSubmitDisabled ? styles.disabled : ''}`}>
          <Button
            classname="red"
            type="submit"
            onClick={isSubmitDisabled ? undefined : () => onClick(value)}
            disabled={isSubmitDisabled}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </>
  );
};

export default SingleButtonForm;
